import React from 'react'

import ReviewMethodologyModal from 'components/ReviewMethodologyModal'
import Typography from 'components/Typography'

import classes from './Methodology.module.scss'

/** @type {import("./types").default} */
const Methodology = ({ category, facet, listings }) => (
  <>
    <Typography variant="heading-lg" component="h3" className={classes.root}>
      How we picked the {listings.length} top rated products
    </Typography>

    <Typography component="p">
      We chose the high-performing solutions on this list based on verified user ratings on our site. Depending on
      available data, qualifying products either had to be among the most user-reviewed or the most searched-for
      products in the {category.toLowerCase()} software category. They also needed to have sufficient reviews about{' '}
      {facet}, have a minimum user rating of 3 out of 5 for that feature, and show evidence of U.S. market presence. We
      then added a distinction for the product with the highest rating for {facet} based on our proprietary ratings and
      reviews. Sponsorship or client status has no influence on the selection of these products, but it may impact the
      order in which products appear.
    </Typography>

    <Typography className={classes.learnMoreAboutReviews} data-testid="methodology-text">
      <ReviewMethodologyModal targetComponent="methodology_best-list" />
    </Typography>
  </>
)

export default Methodology
